import { useCallback, useContext, useState } from 'react';
import { message } from 'antd';
import { EnrollmentContext } from '../providers/EnrollmentContextProvider';
import enrollmentAction from '../providers/EnrollmentContextProvider/enrollmentAction';
import LegalEnrollmentApi from '../domain/EnrollmentLegal/api-enrollmentLegal';
import { EnrollmentFormContext } from '../providers/EnrollmentFormContextProvider';

export default function useEnrollmentUpdate() {
  const [isLoading, setLoading] = useState(false);

  const { dispatch, enrollmentId } = useContext(EnrollmentContext);

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const updateEnrollment = useCallback(
    (data, callback) => {
      setLoading(true);

      LegalEnrollmentApi.updateLegalEnrollment(enrollmentId, data)
        .then((response) => {
          const enrollment = response.data;

          dispatch({ type: enrollmentAction.SET_ENROLLMENT, payload: response.data });

          enrollmentForm.setFieldsValue({
            legalRepresentatives: enrollment.legalRepresentatives,
          });
          callback?.();
        })
        .catch((error) =>
          message.error(
            error.message || 'Ocurrio un error al actualizar los datos. Intente nuevamente'
          )
        )
        .finally(() => {
          setLoading(false);
        });
    },
    [enrollmentId, setLoading, dispatch]
  );

  return [updateEnrollment, isLoading];
}
